// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AnalyzerProbabilityCalculationMode;
(function (AnalyzerProbabilityCalculationMode) {
    AnalyzerProbabilityCalculationMode[AnalyzerProbabilityCalculationMode["None"] = 0] = "None";
    AnalyzerProbabilityCalculationMode[AnalyzerProbabilityCalculationMode["Single"] = 1] = "Single";
    AnalyzerProbabilityCalculationMode[AnalyzerProbabilityCalculationMode["OR"] = 2] = "OR";
    AnalyzerProbabilityCalculationMode[AnalyzerProbabilityCalculationMode["AND"] = 3] = "AND";
})(AnalyzerProbabilityCalculationMode || (AnalyzerProbabilityCalculationMode = {}));
